export enum WidgetDetailsTabEnum {
  WidgetItems = "WIDGET_ITEMS",
  Setup = "SETUP",
  Details = "DETAILS",
  Notes = "NOTES",
}
